export const QUEUE_NAMES = {
    reviewAnswers: 'MarketplaceReviews',
    aiAnalysis: 'MarketplaceReviewsAiAnalysis',
    autoReplies: 'MarketplaceReviewsAutoReplies',
    sync: 'MarketplaceReviewsSync',
    reportRollups: 'MarketplaceReviewsReportRollups',
    aiUsage: 'MarketplaceReviewsAiUsage',
    answerKindRollups: 'MarketplaceReviewsAnswerKindRollups',
    notifications: 'MarketplaceReviewsNotifications',
} as const;

export type QueueName = (typeof QUEUE_NAMES)[keyof typeof QUEUE_NAMES];

export const QUEUE_NAMES_IN_STABLE_ORDER = Object.freeze([
    QUEUE_NAMES.reviewAnswers,
    QUEUE_NAMES.aiAnalysis,
    QUEUE_NAMES.autoReplies,
    QUEUE_NAMES.sync,
    QUEUE_NAMES.reportRollups,
    QUEUE_NAMES.aiUsage,
    QUEUE_NAMES.answerKindRollups,
    QUEUE_NAMES.notifications,
]) as readonly QueueName[];

const KNOWN_QUEUE_NAME_SET = new Set<string>(QUEUE_NAMES_IN_STABLE_ORDER);

export const isKnownQueueName = (queueName: string): queueName is QueueName => KNOWN_QUEUE_NAME_SET.has(queueName);

export const QUEUE_JOBS = {
    createReviewAnswer: 'createReviewAnswer',
    updateReviewAnswer: 'updateReviewAnswer',
    analyzeSelectedReviewsAi: 'analyzeSelectedReviewsAi',
    generateReviewAiAnswer: 'generateReviewAiAnswer',
    generateReviewAiAnswerManual: 'generateReviewAiAnswerManual',
    refreshReviewAiTemplates: 'refreshReviewAiTemplates',
    processAutoReplies: 'processAutoReplies',
    processAutoReplyAiAnswer: 'processAutoReplyAiAnswer',
    syncMarketplaceAllClientsReviews: 'syncMarketplaceAllClientsReviews',
    syncMarketplaceWebhookEventsAllClientsReviews: 'syncMarketplaceWebhookEventsAllClientsReviews',
    rebuildReportSummaryRollups: 'rebuildReportSummaryRollups',
    reconcileAiUsageOutbox: 'reconcileAiUsageOutbox',
    reconcileAnswerKindOutbox: 'reconcileAnswerKindOutbox',
    dispatchMaxNotifications: 'dispatchMaxNotifications',
    sendMaxNotificationDelivery: 'sendMaxNotificationDelivery',
} as const;
